import { render } from "./CouponForm.vue?vue&type=template&id=b70fd13a"
const script = {}

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__